import { CurrencyPipe, DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MotorBikeQuoterStoreService } from '../../../store/motor-bike-quoter-store';
import { ResumeItemComponent } from '@webapp/core/ui/components/resume-item/resume-item.component';
import { IResumeItem } from '@webapp/quoter/interfaces/quoter.interface';

@Component({
  selector: 'app-motor-bike-resume',
  imports: [ResumeItemComponent],
  providers: [DatePipe, CurrencyPipe],
  templateUrl: './motor-bike-resume.component.html',
  styleUrl: './motor-bike-resume.component.scss',
})
export class MotorBikeResumeComponent {
  private motorBikeQuoterStoreService = inject(MotorBikeQuoterStoreService);
  readonly motorBikeQuoterStore =
    this.motorBikeQuoterStoreService.state.asReadonly();
  datePipe = inject(DatePipe);
  currencyPipe = inject(CurrencyPipe);
  items: IResumeItem[] = [
    {
      title: 'Marca',
      text: this.motorBikeQuoterStore().insurable.brand ?? '',
    },
    {
      title: 'Modelo',
      text: this.motorBikeQuoterStore().insurable.model ?? '',
    },

    {
      title: 'Año',
      text: this.motorBikeQuoterStore().insurable.year.toString(),
    },
    {
      title: 'Suma Asegurada',
      text: `${this.currencyPipe.transform(
        this.motorBikeQuoterStore().insurable.sumInsured,
        'ARS',
        'symbol-narrow',
        '1.2-2',
        'es-AR'
      )}`,
    },
    {
      title: 'Patente',
      text: this.motorBikeQuoterStore().insurable.plate ?? '',
    },
    {
      title: 'Motor',
      text: this.motorBikeQuoterStore().insurable.motor ?? '',
    },
    {
      title: 'Chasis',
      text: this.motorBikeQuoterStore().insurable.chasis ?? '',
    },
  ];
}
